<template>
  <section class="custom-slider-home-pr sk-home__section--skeleton sk-home__our-collection--skeleton">
    <div class="sk-home__container">
      <div class="title_collection">
        <div class="sk-home__heading-title"></div>
      </div>
      <div class="main-custom-slider">
        <div class="custom-slider custom-slider--skeleton">
          <div class="custom-slide-tab-skeleton" v-for="i in 4" :key="i"></div>
        </div>
      </div>
      <div class="custom-content-wrapper home-our-collection">
        <SkeletonCarousel />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import SkeletonCarousel from "~/components/Campaign/Carousel/SkeletonCarousel.vue";
</script>

<style scoped lang="scss">
.sk-home__our-collection--skeleton {
  min-height: 520px;
  @media (max-width: 767.98px) {
    min-height: 460px;
  }
  .title_collection {
    .sk-home__heading-title {
      height: 38px;
      width: 220px;
      max-width: 60%;
      margin: 0 0 15px;
      border-radius: 4px;
      background: linear-gradient(90deg, #ececec 0px, #ddd 40px, #ececec 80px);
      background-size: 200% 100%;
      animation: 1.5s shine linear infinite;
    }
  }
  .custom-slider--skeleton {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    .custom-slide-tab-skeleton {
      width: 120px;
      height: 36px;
      border-radius: 4px;
      background: linear-gradient(90deg, #ececec 0px, #ddd 40px, #ececec 80px);
      background-size: 200% 100%;
      animation: 1.5s shine linear infinite;
    }
  }
}
</style>
